import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'atn-datagrid-table',
  templateUrl: './datagrid-table.component.html',
  styleUrls: ['./datagrid-table.component.scss']
})
export class DatagridTableComponent implements OnInit {
  @Input() columns: Array<Object> = [];
  @Input() data: Array<Object> = [];
  @Input() filters: Array<Object> = [];

  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/datagrid-table/datagrid-table.component.ts